
function FormulaireEcole({recorderInspections,code,setCode,commune,setCommune,error_submission,submission,confirmSave,HandleSubmit,inspection,children,title,handleMouse,handleMouseleave,handlekeyUpgain,onclick,nom,province,province_educationnelle,type,ville,arrete,setNom,setProvince,setProvince_educationnelle,setType,setVille,setArrete,setInspection,numero_agreement,setNumero_agreement,adresse,setAdresse,inspections,setInspections}){
   
    return(
        <>
        <div className="container py-4">
    <form className="card shadow-sm border-0 p-4 p-md-5" onSubmit={confirmSave}>
        <legend className="mb-4">
            <h3 className="fw-bold text-primary border-bottom pb-2">
                {title}
            </h3>
        </legend>

        {/* Ligne 1 : Nom de l'école */}
        <div className="row g-3 mb-3">
            <div className="col-12 col-lg-6">
                <label className="form-label fw-semibold" htmlFor="nomEcole">NOM DE L'ÉCOLE</label>
                <input type="text" id="nomEcole" className="form-control form-control-lg bg-light" value={nom} onChange={(e)=>setNom(e.target.value.toLowerCase())} placeholder="Saisir le nom complet" />                          
            </div>
            <div className="col-12 col-lg-6">
                <label className="form-label fw-semibold" htmlFor="codeEcole">CODE DE L'ÉCOLE</label>
                <input type="text" id="codeEcole" className="form-control form-control-lg bg-light" value={code} onChange={(e)=>setCode(e.target.value.toUpperCase())} placeholder="Ex: 123456" />                          
            </div>
        </div>

        {/* Ligne 2 : Localisation administrative */}
        <div className="row g-3 mb-3">
            <div className="col-md-6 col-lg-4">
                <label className="form-label fw-semibold">PROVINCE</label>
                <select className="form-select form-select-lg" value={province.toUpperCase()} onChange={(e)=>setProvince(e.target.value.toUpperCase())}>
                                    <option value="BAS-UELE">BAS-UELE</option>
                                    <option value="ÉQUATEUR">ÉQUATEUR</option>
                                    <option value="HAUT-KATANGA">HAUT-KATANGA</option>
                                    <option value="HAUT-LOMAMI">HAUT-LOMAMI</option>
                                    <option value="HAUT-UELE">HAUT-UELE</option>
                                    <option value="ITURI">ITURI</option>
                                    <option value="KASAÏ">KASAÏ</option>
                                    <option value="KASAÏ-CENTRAL">KASAÏ-CENTRAL</option>
                                    <option value="KASAÏ-ORIENTAL">KASAÏ-ORIENTAL</option>
                                    <option value="KINSHASA">KINSHASA</option>
                                    <option value="KONGO-CENTRAL"> KONGO-CENTRAL</option>
                                    <option value="KWANGO"> KWANGO</option>
                                    <option value="KWILU"> KWILU</option>
                                    <option value="LOMAMI"> LOMAMI</option>
                                    <option value="LUALABA"> LUALABA</option>
                                    <option value="MAI-NDOMBE"> MAI-NDOMBE</option>
                                    <option value="MANIEMA"> MANIEMA</option>
                                    <option value="MONGALA"> MONGALA</option>
                                    <option value="NORD-KIVU"> NORD-KIVU</option>
                                    <option value="NORD-UBANGI"> NORD-UBANGI</option>
                                    <option value="SANKURU"> SANKURU</option>
                                    <option value="SUD-KIVU"> SUD-KIVU</option>
                                    <option value="SUD-UBANGI"> SUD-UBANGI</option>
                                    <option value="TANGANYIKA"> TANGANYIKA</option>
                                    <option value="TSHOPO"> TSHOPO</option>
                                    <option value="TSHUAPA"> TSHUAPA</option>
                            </select>
                        </div>
            <div className="col-md-6 col-lg-4">
                <label className="form-label fw-semibold">PROVINCE ÉDUCATIONNELLE</label>
                <select className="form-select form-select-lg" value={province_educationnelle} onChange={(e)=>setProvince_educationnelle(e.target.value)}>
                    <option value="">Sélectionner...</option>
                    {recorderInspections?.map((inspect) => (
                        <option key={inspect?.id} value={inspect?.id}>{inspect?.province_educationnelle}</option>
                    ))}
                </select>
            </div>
            <div className="col-md-12 col-lg-4">
                <label className="form-label fw-semibold">TYPE D'ÉCOLE</label>
                <select className="form-select form-select-lg" value={type} onChange={(e)=>setType(e.target.value.toLowerCase())}>
                    <option value="">Choix du type</option>
                    <option value="non conventionné">Non Conventionnée</option>
                    <option value="conventionnée catholique">Conventionnée Catholique</option>
                    <option value="conventionnée protestante">Conventionnée Protestante</option>
                    <option value="ecole privée">École Privée</option>
                </select>
            </div>
        </div>

        {/* Ligne 3 : Détails Ville/Commune/Adresse */}
        <div className="row g-3 mb-3">
            <div className="col-md-4">
                <label className="form-label fw-semibold">VILLE</label>
                <input type="text" className="form-control form-control-lg" value={ville} onChange={(e)=>setVille(e.target.value.toLowerCase())} />                          
            </div>
            <div className="col-md-4">
                <label className="form-label fw-semibold">COMMUNE</label>
                <input type="text" className="form-control form-control-lg" value={commune} onChange={(e)=>setCommune(e.target.value.toLowerCase())} />                          
            </div>
            <div className="col-md-4">
                <label className="form-label fw-semibold">ADRESSE</label>
                <input type="text" className="form-control form-control-lg" value={adresse} onChange={(e)=>setAdresse(e.target.value.toLowerCase())} />                          
            </div>
        </div>

        {/* Ligne 4 : Légal */}
        <div className="row g-3 mb-4">
            <div className="col-md-6">
                <label className="form-label fw-semibold">ARRÊTÉ</label>
                <input type="text" className="form-control form-control-lg" value={arrete} onChange={(e)=>setArrete(e.target.value.toLowerCase())} />                          
            </div>
            <div className="col-md-6">
                <label className="form-label fw-semibold">NUMÉRO AGRÉMENT</label>
                <input type="text" className="form-control form-control-lg" value={numero_agreement} onChange={(e)=>setNumero_agreement(e.target.value)} />                          
            </div>
        </div>

        {/* Messages d'alerte */}
        <div className="row">
            <div className="col-12 text-center mb-3">
                {error_submission && (
                    <div className="alert alert-danger py-2" role="alert">
                        ⚠️ Veuillez compléter tous les champs obligatoires
                    </div>
                )}
                {submission && (
                    <div className="alert alert-success py-2" role="alert">
                        ✅ L'école a été enregistrée avec succès
                    </div>
                )}
            </div>
        </div>

        <div className="row mb-3">
            {children}
        </div>

        {/* Bouton d'action */}
        <div className="row mt-2">
            <div className="col-12">
                <button type="submit" className="btn btn-primary btn-lg px-5 shadow-sm w-100 w-md-auto">
                    Enregistrer l'école
                </button>
            </div>
        </div>
    </form>
</div>

        </>
    )
}
export default FormulaireEcole